module.exports = __webpack_public_path__ + "img/reset-password.605bdd73.svg";